import React from "react";
import LearnWidgetsList from "../components/LearnWidgetList";

import SvgIcon from "../../../../parts/SvgIcon";
import { WidgetsListManager } from "../components/widgetManager/components/WidgetsListManager";
import { ExploreSelector } from "../components/ExploreSelector";
import { widgetTypesList } from "../data/widgetsLists";

const WidgetsMain = ({ locals }) => {
  return (
    <main className="widgets">
      <header>
        <hgroup className="mobile-hidden">
          <h3>Widgets</h3>
          <p className="p4">
            Widgets are custom features you can add to your app to create more
            value for your users. Explore the options available below to begin
            building out custom features in your app.
          </p>
        </hgroup>
        <ExploreSelector widgetTypesList={widgetTypesList} />
        <a
          href={`/actions/refresh?modal[type]=create-widget`}
          role="button"
          data-button-type="primary"
        >
          <SvgIcon src="/img/new-icons/add.svg" noFilterOnLight={true} />
          <span>Add New Widget</span>
        </a>
      </header>
      <section>
        <LearnWidgetsList widgetTypesList={widgetTypesList} />
        <WidgetsListManager locals={locals} />
      </section>
    </main>
  );
};

export default WidgetsMain;
